import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { FaFilter } from "react-icons/fa";
// import { HiDownload } from "react-icons/hi";
import { DataGrid } from "@mui/x-data-grid";
import { useAuth } from "../../context/AuthProvider";
import { HttpService } from "../../service/HttpService";
import DateTimeModal from "../Schedule/ScheduleListAdd/DateTimeModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 600,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 3,
  outline: "unset",
};

const SopFileHistoryModal = ({ open, handleClose, data }) => {
  const { setShowLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [sopDetails, setSopDetails] = useState([]);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [label, setLabel] = useState("");
  const historyDateFilter = localStorage.getItem("sopFileHistoryDateFilter");
  const dateFilterData = historyDateFilter
    ? JSON.parse(historyDateFilter)
    : null;
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio || "month"
  );

  const radioOptions = [
    { value: "today", label: "Today" },
    { value: "week", label: "This Week" },
    { value: "month", label: "This Month" },
    { value: "specific", label: "Specific Date Range" },
  ];

  const handleRadioChange = () => {
    const setlabel =
      radioOptions.find((option) => option.value === selectedRadio)?.label ||
      "";
    setLabel(setlabel);
  };

  const fetchSopFileHistory = async () => {
    setLoading(true);
    try {
      // Adjust the endpoint as needed for file history
      const response = await httpService.get(
        `sops/getById/${data.id}?start_date=${startDate}&end_date=${endDate}`
      );
      setHistory(
        response?.data?.sop_file_history?.map((item, idx) => ({
          id: item.id,
          emp_name: item.emp_name,
          history_filename: item.history_filename,
          viewed_at: item.viewed_at,
        })) || []
      );
      setSopDetails(response?.data?.sop_history_details);
    } catch (error) {
      setHistory([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSopFileHistory();
    handleRadioChange();
  }, [data?.id]);

  const columns = [
    // {
    //   field: "select_All",
    //   headerName: "",
    //   minWidth: 50,
    //   align: "center",
    //   headerAlign: "center",
    //   sortable: false,
    //   disableColumnMenu: true,
    //   renderCell: (params) => (
    //     <Checkbox
    //       checked={isAllSelected ? true : isIdSelected(params.row.id)}
    //       onChange={() => toggleId(params.row.id)}
    //     />
    //   ),
    //   renderHeader: () => (
    //     <Checkbox
    //       checked={isAllSelected}
    //       onChange={handleHeaderCheckboxChange}
    //     />
    //   ),
    // },
    // {
    //   field: "action",
    //   headerName: "Action",
    //   minWidth: 100,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: (params) => (
    //     <>
    //       <div className="action_icon-weap">
    //         <IconButton onClick={(e) => handleMenuClick(e, params.row.id)}>
    //           <GridMoreVertIcon />
    //         </IconButton>
    //       </div>
    //       {anchorEl && dataId === params.row.id && (
    //         <Popover
    //           className="popup-menu"
    //           key={dataId}
    //           open={Boolean(anchorEl)}
    //           anchorEl={anchorEl}
    //           onClose={handleCloseMenu}
    //           anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    //           transformOrigin={{ vertical: "top", horizontal: "right" }}
    //         >
    //           <MenuItem
    //             onClick={() => {
    //               handleDelete(params.row.id);
    //               handleCloseMenu();
    //             }}
    //             className="menu-list-items"
    //           >
    //             <div className="menu-list-items-text">Delete</div>
    //             <GoTrash style={{ cursor: "pointer" }} />
    //           </MenuItem>
    //         </Popover>
    //       )}
    //     </>
    //   ),
    // },
    {
      field: "history_filename",
      headerName: "File Name",
      flex: 1,
      minWidth: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <span style={{ fontWeight: 500 }}>
          {params.row.history_filename || "--"}
        </span>
      ),
    },
    {
      field: "emp_name",
      headerName: "Employee Name",
      flex: 1,
      minWidth: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => <span>{params.row.emp_name || "--"}</span>,
    },
    {
      field: "viewed_at",
      headerName: "Viewed At",
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD-MM-YYYY hh:mm A") : "--",
    },
  ];

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Box display="flex" alignItems="center" gap={1} flexWrap={"wrap"}>
              <Typography variant="h6">History of </Typography>
              <Typography variant="h6" color={"#000"}>
                {data?.name && data?.name}
              </Typography>
              <Typography variant="h6">{label ? `(${label})` : ""}</Typography>
            </Box>
            <Box display={"flex"} alignItems="center">
              {/* <button
                type="submit"
                variant="primary"
                className=""
                onClick={() => onDownloadClick(true)}
                style={{
                  width: "35px",
                  height: "35px",
                  borderRadius: "4px",
                  marginRight: "5px",
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  border: "1px solid transparent",
                }}
              >
                <HiDownload size={22} />
              </button> */}
              <button
                type="submit"
                className="filter-btn-custm"
                onClick={() => setOpenDateModal(true)}
                style={{
                  width: "35px",
                  height: "35px",
                  borderRadius: "4px",
                  marginRight: "5px",
                }}
              >
                <FaFilter />
              </button>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
          {/* <DataGrid
            rows={history}
            columns={columns}
            autoHeight
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
            sx={{
              background: "#fff",
              borderRadius: 2,
              [`& .MuiDataGrid-cell`]: { py: 1 },
            }}
            hideFooter
          /> */}
          <TableContainer
            component={Paper}
            elevation={0}
            style={{ maxHeight: "400px" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Date</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Employee Name</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {history.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {dayjs(row.viewed_at).format("DD-MM-YYYY hh:mm A")}
                    </TableCell>
                    <TableCell>{row.emp_name ? row.emp_name : "--"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
      {openDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => setOpenDateModal(false)}
          setStartDate={(e) => setStartDate(e)}
          setEndDate={(e) => setEndDate(e)}
          open={openDateModal}
          fetchSchedule={() => {
            fetchSopFileHistory();
            const dateFilter = {
              startDate: startDate,
              endDate: endDate,
              selectedRadio: selectedRadio,
            };
            localStorage.setItem(
              "sopFileHistoryDateFilter",
              JSON.stringify(dateFilter)
            );
            handleRadioChange();
          }}
          selectedRadio={selectedRadio}
          setSelectedRadio={(e) => setSelectedRadio(e)}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </>
  );
};

export default SopFileHistoryModal;
